export default "__VITE_ASSET__64NMElVU__"